import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';

export class IAccountEmployee extends BaseEntity {
    dateTimeTo: any;
    accountId: string;
    employeeId: string;
    employeeDisplayName: string;
}

export class AccountEmployeeService extends BaseService<IAccountEmployee> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'crm/AccountEmployees');
    }
}


// WEBPACK FOOTER //
// ./src/app/services/accountEmployee.service.ts